import { type UserTypeName, type UserGroup, type SurveyStep } from './types'

export function getUserType(userGroup: UserGroup | null): UserTypeName {
  switch (userGroup) {
    case 'college':
      return 'UC'
    case 'highschool':
      return 'H'
    case 'repeater':
      return 'H4'
    case 'middleschool':
      return 'M'
    case 'elemantaryschool':
      return 'E'
    case 'general':
      return 'AG'
    case 'generalCollege':
      return 'UC'
    default:
      throw new Error('Not exist user type')
  }
}

export function getUserGroup(userType: UserTypeName | null): UserGroup | null {
  if (userType === null) return null

  switch (userType) {
    case 'AG':
      return 'general'
    case 'E':
      return 'elemantaryschool'
    case 'H':
      return 'highschool'
    case 'H4':
      return 'repeater'
    case 'M':
      return 'middleschool'
    case 'UC':
      return 'college'
    default:
      throw new Error('Not exist user type')
  }
}

/**
 * V2: 그룹과 무관하게 [닉네임 → 시험 선택 → 그룹 선택] 순서로 고정.
 * 학교/학과/학년도/학년/반 스텝은 V2에서 미수집으로 제거됨.
 * skipLastStep은 계정 설정 모달에서 시험만 수정할 때 그룹 스텝을 생략하는 용도.
 */
export function getSurveyStepByUserGroup(
  userGroup: UserGroup,
  skipFirstStep = false,
  skipLastStep = false,
): SurveyStep[] {
  const steps: SurveyStep[] = !skipLastStep
    ? ['userNickname', 'examinations', 'userGroup']
    : ['userNickname', 'examinations']

  return skipFirstStep ? steps.slice(1) : steps
}
